<template>
	<div class="column is-5">
		<div class="field is-maxed">
			<div class="control has-icons-left is-expanded">
				<DateField :value="startDate" @input="$emit('startDateInput', $event)" @enter="$emit('enter')" />
				-
				<DateField :value="endDate" @input="$emit('endDateInput', $event)" @enter="$emit('enter')" />
			</div>
		</div>
	</div>
</template>

<script>
	import DateField from "./DateField.vue"

	export default {
		components: {
			DateField
		},
		props: {
			startDate: [Number, String],
			endDate: [Number, String]
		}
	}
</script>